import React, { useCallback } from 'react';
import useTranslate from 'common/I18n/Interpreter';
import { SettingsManager, useSettings } from '@atlas/core';
import { ThemeChanger, Label } from '@atlas/ui';

const ChangeTheme = () => {
  const t = useTranslate();
  const { theme } = useSettings();
  const isNightMode = theme === 'dark';

  const changeThemeHandler = useCallback(() => {
    SettingsManager.updateSettings({ theme: isNightMode ? 'light' : 'dark' });
  }, [isNightMode]);

  return (
    <div className="menu-item-container change-theme-container" onClick={changeThemeHandler}>
      <div className="menu-item-text">
        <Label className="title-small-text" message="Change theme" />
        <span className="sub-label">
          {t('You selected')} {t(theme)} {t('theme')}
        </span>
      </div>
      <div className="menu-item-icon-controls theme">
        <ThemeChanger isNightMode={isNightMode} onClick={changeThemeHandler} />
      </div>
    </div>
  );
};

export default ChangeTheme;
